import { endpoints } from "../utils/endpoints";
import { apiService } from "./ApiService";

class OrderServices {
  async getMediaData(mediaId: string) {
    try {
      const response = await apiService
        .axiosCruds()
        .get(endpoints.getMediaById(mediaId));
      return response.data;
    } catch (error) {
      throw new Error();
    }
  }

  async getInvoiceMediaPath(invoiceMediaId: string): Promise<string> {
    const mediaResponse = await this.getMediaData(invoiceMediaId);
    const path = mediaResponse?.path;
    if (!path) {
      throw new Error("Invoice path not available");
    }
    return path;
  }

  async downloadInvoiceForOrder(invoiceMediaId: any) {
    try {
      const invoicePath = await this.getInvoiceMediaPath(invoiceMediaId);
      window.open(invoicePath, "_blank");
    } catch (error) {
      alert("Invoice is not available");
    }
  }

  async getMobileConfig() {
    const response = await apiService.axiosCruds().get(endpoints.mobileConfig);
    return response.data;
  }

  async updateOrderMetaInfo(orderId: string, payload: any) {
    try {
      const response = await apiService
        .axiosCruds()
        .patch(endpoints.updateOrderMetaInfo(orderId), payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async transitionOrderStatus(orderId: string, action: string) {
    try {
      const response = await apiService
        .axiosCruds()
        .post(`${endpoints.garaazTransition(orderId)}?action=${action}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async mergeInvoices(mediaIds: string[]): Promise<Blob> {
    try {
      const response = await apiService.axiosCruds().post(
        endpoints.mergeInvoices,
        { mediaIds },
        {
          responseType: "arraybuffer",
          headers: {
            Accept: "application/pdf, application/octet-stream, */*",
          },
        }
      );

      if (!response.data || response.data.byteLength === 0) {
        throw new Error("Empty response received from server");
      }

      const blob = new Blob([response.data], { type: "application/pdf" });

      if (blob.size === 0) {
        throw new Error("Invalid PDF: empty file received");
      }

      return blob;
    } catch (error: any) {
      let errorMessage = "Failed to merge invoices. Please try again later.";
      const contentType = error?.response?.headers?.["content-type"];

      if (contentType?.includes("application/json")) {
        try {
          const textDecoder = new TextDecoder();
          const jsonText = textDecoder.decode(error?.response?.data);
          const errorData = JSON.parse(jsonText);
          errorMessage = errorData?.message || errorData?.error || errorMessage;
        } catch {}
      }
      throw new Error(errorMessage);
    }
  }
}

export default new OrderServices();
